<template>
  <div class="download-banner max-page">
    <div class="img-wrap">
      <img
        src="@/assets/imgs/first-win.png"
        v-if="flag == 'win'"
      />
      <img
        src="@/assets/imgs/first-mac.png"
        v-if="flag == 'mac'"
      >
      <img
        src="@/assets/imgs/first-ios.png"
        v-if="flag == 'ios'"
      >
      <img
        src="@/assets/imgs/first-ios.png"
        v-if="flag == 'android'"
      >
      <img
        src="@/assets/imgs/first-win-speed.png"
        v-if="flag == 'winjs'"
      >
    </div>
    <div class="wrapper">
      <div class="content">
        <div
          class="left"
          v-if="flag == 'win'"
        >
          <div class="text">
            <p class="tit">WIN版</p>
            <h3>给你快速稳定的全新体验</h3>
            <h4>版本：V5.92.0824.1111 | 101MB</h4>
            <h4>更新时间：2023-8-30</h4>
          </div>
        </div>
        <div
          class="left"
          v-if="flag == 'winjs'"
        >
          <div class="text">
            <p class="tit">WIN极速版</p>
            <h3>给你更快速纯粹的播放操作体验</h3>
            <h4>版本：V9.06.0912.1111 | 74.3MB</h4>
            <h4>更新时间：2023-09-18</h4>
          </div>
        </div>
        <div
          class="left"
          v-if="flag == 'mac'"
        >
          <div class="text">
            <p class="tit">Mac版</p>
            <h3>给你快速稳定的全新体验</h3>
            <h4>版本：V1.1.6 | 7.90MB</h4>
            <h4>更新时间： 2017-08-25</h4>
          </div>
        </div>
        <div
          class="left"
          v-if="flag == 'android'"
        >
          <div class="text">
            <p class="tit">Android版</p>
            <h3>给你快速稳定的全新体验</h3>
            <h4>版本：V8.6.4.1 | 71MB</h4>
            <h4>更新时间： 2023-03-20</h4>
          </div>
        </div>
        <div
          class="left"
          v-if="flag == 'ios'"
        >
          <div class="text">
            <p class="tit">IOS版</p>
            <h3>给你快速稳定的全新体验</h3>
            <h4>版本：V6.2.0.1 | 104.5MB</h4>
            <h4>更新时间： 2023-03-17</h4>
          </div>
        </div>
        <div
          class="btn"
          @click="handleDown"
        >
          <img src="@/assets/imgs/download.png">
          <span>立即下载</span>
        </div>
      </div>
      <div
        class="btn-box"
        ref="btnChange"
      >

        <!-- mac版 -->
        <p
          :class="flag == 'mac'? 'active' :''"
          @click="tabChange('mac')"
        >
          <img src="@/assets/imgs/icon-mac-active.png">
          <span>Mac版</span>
        </p>

        <!-- win版 -->
        <p
          :class="flag == 'win'? 'active' :''"
          @click="tabChange('win')"
        >
          <img src="@/assets/imgs/icon-win-active.png">
          <span>WIN版</span>
        </p>

        <!-- 极速版 -->
        <p
          :class="flag == 'winjs'? 'active' :''"
          @click="tabChange('winjs')"
        >
          <img src="@/assets/imgs/icon-win-active.png">
          <span>极速版</span>
        </p>

        <!-- IOS版 -->
        <p
          :class="flag == 'ios'? 'active' :''"
          @click="tabChange('ios')"
        >
          <img
            v-if="flag == 'ios'"
            src="@/assets/imgs/icon-ios-active.png"
          >
          <img
            v-else
            src="@/assets/imgs/icon-ios-active.png"
          >
          <span>IOS版</span>
        </p>
        <!-- Android版 -->
        <p
          :class="flag == 'android'? 'active' :''"
          @click="tabChange('android')"
        >
          <img
            v-if="flag == 'android'"
            src="@/assets/imgs/icon-android-active.png"
          >
          <img
            v-else
            src="@/assets/imgs/icon-android-active.png"
          >
          <span>Android版</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Download',
  data () {
    return {
      flag: 'android',
      url: {
        'win': 'http://dl.baofeng.com/baofeng5/bf5_new.exe',
        'winjs': 'http://dl.baofeng.com/baofeng5/bf16.exe',
        'mac': 'https://apps.apple.com/cn/app/%E6%9A%B4%E9%A3%8E%E5%BD%B1%E9%9F%B3/id1035547244?mt=12',
        'android': 'http://dl.baofeng.com/baofeng5/android.apk',
        'ios': 'https://apps.apple.com/cn/app/%E6%9A%B4%E9%A3%8E%E5%BD%B1%E9%9F%B3-baofeng-player/id538248967'
      }
    }
  },

  methods: {
    handleDown () {
      window.open(this.url[this.flag])
    },
    tabChange (type) {
      this.flag = type
    }
  }
}
</script>

<style lang="less" scoped>
.download-banner {
  position: relative;
  height: 340px;
  box-sizing: content-box;
  background: url('~@/assets/imgs/download-bg.png') no-repeat;
  background-position: center;
  .img-wrap {
    position: absolute;
    left: 10%;
    width: 30%;
    text-align: center;
    img {
      width: 100%;
      height: 100%;
      max-width: 400px;
    }
  }
  .wrapper {
    padding-left: 40%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .content {
      height: 300px;
      width: 350px;
      padding-top: 30px;
      .left img {
        width: 200px;
      }
      .left {
        .text {
          h3 {
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #e1e2e4;
            margin: 12px 0 40px 0;
          }
          h4 {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #8f9ca6;
            margin-top: 10px;
            letter-spacing: 1px;
          }
          .tit {
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #fff;
          }
        }
      }

      .btn {
        width: 170px;
        padding: 8px 15px 12px 15px;
        background: linear-gradient(90deg, #02aaff 0%, #0180ff 100%);
        border-radius: 10px;
        color: #fff;
        text-align: center;
        cursor: pointer;
        margin-top: 30px;
      }
    }

    .btn-box {
      opacity: 0.8;
      color: #f1f1f6;
      background: linear-gradient(#16161c, #13283c);
      padding: 10px;
      border-radius: 10px;
      border: 1px solid #3f3f3f;
      p {
        padding: 9px 20px;
        border-radius: 4px;
        line-height: 20px;
        margin: 10px 0;
        text-align: center;
        cursor: pointer;
        display: flex;
        align-items: center;
        &.active {
          opacity: 1;
          border-radius: 19px;
          background: linear-gradient(90deg, #02aaff 0%, #0180ff 100%);
          color: #fff;
        }
        img {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/homePage/components/Download.vue